<div class="header-container mb-10">
  <!-- <button mat-raised-button (click)="changeLanguage()">{{ language[currentLanguage]['changeTo'] }}</button> -->
  <div class="language-switcher" [ngClass]="{ 'gradient-border-animate in': !islanguageSelected }">
    <app-select placeHolder="Select language"
    [group]="languageForm"
    [control]="language"
    appearance="fill"
    (onChange)="selectLanguage($event)"
    [data]="languages">
    </app-select>
  </div>

  <!-- <div [ngClass]="isHide ? 'visble' : 'hidden'">
    <button class="back" (click)="back()" mat-button>
      <mat-icon matPrefix class="b-icon">chevron_left</mat-icon> BACK
    </button>
  </div> -->
  <div [ngClass]="isCampaignPage ? 'visble' : 'hidden'" *ngIf="!campaignType || campaignType !== 'medical'">
    <button class="f-button" color="primary" [ngClass]="setButtonActive('basic')"  (click)="setForm('basic')">1</button>
    <button class="f-button" color="primary" [ngClass]="setButtonActive('image')"  (click)="setForm('image')" [disabled]="button.image">2</button>
    <!-- <button class="f-button" color="primary" [ngClass]="setButtonActive('advance')" (click)="setForm('advance')" [disabled]="button.advance">3</button> -->
    <button class="f-button" color="primary" [ngClass]="setButtonActive('desc')"  (click)="setForm('desc')" [disabled]="button.desc">3</button>
  </div>
  <div [ngClass]="isCampaignPage ? 'visble' : 'hidden'" *ngIf="campaignType && campaignType == 'medical'">
      <button class="f-button" color="primary" [ngClass]="setButtonActive('basic')"  (click)="setForm('basic')">1</button>
      <button class="f-button" color="primary" [ngClass]="setButtonActive('advance')"  (click)="setForm('advance')" [disabled]="button.image">2</button>
      <button class="f-button" color="primary" [ngClass]="setButtonActive('desc')" (click)="setForm('desc')" [disabled]="button.desc">3</button>
    </div>
  <div [ngClass]="isPreview ? 'visble' : 'hidden'">
    <button mat-raised-button class="preview" (click)="showPreview()">
      <mat-icon class="p-icon">visibility</mat-icon>
      <!-- <mat-icon class="icon icon-preview" matPrefix></mat-icon> -->
      <small style="margin-left: 2px">{{ languagePreview[currentLanguage]['preview'] }}</small>
    </button>
  </div>
</div>
